import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms/Select';
import { useReviews } from './ReviewsProvider';

// latest, oldest, highRating, lowRating
const SEARCH_OPTIONS = [
  { value: 'latest', label: '최신순' },
  { value: 'oldest', label: '오래된순' },
  { value: 'highRating', label: '높은 평점 순' },
  { value: 'lowRating', label: '낮은 평점 순' },
];

const ReviewsFilterSelect = () => {
  const { filterSelect, setFilterSelect } = useReviews();
  return (
    <Select
      value={filterSelect.value}
      onValueChange={(value) => {
        const selected = SEARCH_OPTIONS.find((option) => option.value === value);
        if (selected) setFilterSelect(selected);
      }}
    >
      <SelectTrigger className="h-full w-[160px] border-gr-300 py-[19px] Body5M14">
        <SelectValue placeholder="검색조건" />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {SEARCH_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ReviewsFilterSelect;
